import { DevModeResponseDto } from '@tiendanube/common';
import axios from 'App/axios';

export const getDevMode = async (partnerId?: number) => {
  const { data } = await axios.get<DevModeResponseDto>(
    `v1/settings/developer/${partnerId}`,
  );
  return data;
};
